<template>
    <section class="breadcrumbs">
        <div class="breadcrumbs__container">
            <ol class="breadcrumbs__list" aria-label="Breadcrumb">
                <li class="breadcrumbs__list-item">
                    <NuxtLink :to="`${domain}/${locale}`" class="breadcrumbs__link" external>
                        {{ t('home') }}
                    </NuxtLink>
                </li>
                <li
                    v-for="(breadcrumb, index) in breadcrumbsList"
                    :key="breadcrumb._uid"
                    class="breadcrumbs__list-item"
                >
                    <span v-if="index === breadcrumbsList.length - 1" class="breadcrumbs__item">
                        {{ breadcrumb.text }}
                    </span>
                    <NuxtLink v-else :to="domain + breadcrumb.url" class="breadcrumbs__link">
                        {{ breadcrumb.text }}
                    </NuxtLink>
                </li>
            </ol>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { IL4Breadcrumbs } from '~/types/components/L4Breadcrumbs';

const { locale, t } = useI18n();
const { blok } = defineProps<{ blok: IL4Breadcrumbs }>();
const breadcrumbsList = computed(() => blok.breadcrumbsList);
const domain = useRuntimeConfig().public.SITE_URL;
</script>

<style lang="postcss" scoped>
.breadcrumbs {
    @apply bg-[#393939] text-white;
    &__container {
        @apply pt-6 px-7 md:px-2 lg:px-0 md:container;
    }
    &__list {
        @apply flex flex-wrap text-white text-base;
    }
    &__list-item {
        &:not(:last-child):after {
            content: '/';
            @apply px-1;
        }
    }
    &__item {
        @apply font-normal;
    }
    &__link {
        @apply font-bold hover:underline;
    }
}
</style>
